module.exports = __webpack_public_path__ + "img/tip-di.84ffa071.png";